import { useContext, Dispatch } from 'react';
import { UserDataContext } from '../../store/userData.context';

export function useUserData(): [IJwtDecoded, Dispatch<IJwtDecoded>] {
  return useContext(UserDataContext) as [IJwtDecoded, Dispatch<IJwtDecoded>];
}
